import { IRequest } from "../interfaces/authentication.interface";
import { ILegalResponse } from "../interfaces/legal.interface";
import { strapiRequest } from "./requests.service";

export const getLegalContent = async (locale: string): Promise<IRequest<string>> => {
    try {
        const query = `
            query LegalContent($status: PublicationStatus, $locale: I18NLocaleCode) {
                legalContent(status: $status, locale: $locale) {
                    legalContent
                }
            }`;

        const variables = {
            locale,
            status: "PUBLISHED"
        };

        const response = await strapiRequest.post<ILegalResponse>(`/graphql`, {
            operationName: "LegalContent",
            query,
            variables
        });

        return { success: true, data: response.data.data.legalContent ?? "" };
    } catch (error: any) {
        return { success: false, data: [] as any };
    }
};
